import { render, staticRenderFns } from "./ListMarkets.vue?vue&type=template&id=1fd61f61&scoped=true&"
import script from "./ListMarkets.vue?vue&type=script&lang=js&"
export * from "./ListMarkets.vue?vue&type=script&lang=js&"
import style0 from "./ListMarkets.vue?vue&type=style&index=0&id=1fd61f61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd61f61",
  null
  
)

export default component.exports